import React from 'react';
import { motion } from 'framer-motion';
export function TimelineSection() {
  const timeline = [{
    period: 'Weeks 2–4',
    description: 'Most users notice reduced scalp itchiness and sensitivity. This is an early indicator that the anti-inflammatory effect is active — not the hair result itself, but the first sign the mechanism is working.'
  }, {
    period: 'Months 3–4',
    description: 'Reduced daily shedding. Early follicle stabilization. For consistent users, this is when the trajectory starts to shift. You may not see new density yet — but the loss typically slows.'
  }, {
    period: 'Months 4–6',
    description: 'The window where measurable hair density improvements can become visible for consistent users. This is when before/after photos start telling a different story.'
  }];
  return <section className="w-full bg-bg-secondary py-20 px-4" data-id="element-278">
      <div className="max-w-5xl mx-auto" data-id="element-279">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-280">
          {/* Section Label */}
          <p className="text-accent-red font-semibold text-sm uppercase tracking-wider mb-4" data-id="element-281">
            Honest Expectations
          </p>

          {/* Headline */}
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-6" data-id="element-282">
            What to Expect — and When.
          </h2>

          <p className="text-lg text-text-secondary mb-12" data-id="element-283">
            Hair biology operates slowly. We won't pretend otherwise. Men who
            get results are men who understand what they're committing to.
          </p>

          {/* Timeline Cards */}
          <div className="space-y-6 mb-12" data-id="element-284">
            {timeline.map((phase, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-bg-primary border-l-4 border-accent-red rounded-lg p-6" data-id="element-285">
                <h3 className="text-xl font-bold text-accent-red mb-3" data-id="element-286">
                  {phase.period}
                </h3>
                <p className="text-text-secondary leading-relaxed" data-id="element-287">
                  {phase.description}
                </p>
              </motion.div>)}
          </div>

          <p className="text-lg text-text-primary font-semibold text-center" data-id="element-288">
            We are not promising full restoration. We are promising a
            clinically-grounded mechanism, a correctly-built device, and an
            honest protocol.
          </p>
        </motion.div>
      </div>
    </section>;
}